import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import Home from "./pages/Home";
import WsjPedidos from "./pages/WsjPedidos";
import WebDevelopment from "./pages/WebDevelopment";
import Ecommerce from "./pages/Ecommerce";
import MarketingDigital from "./pages/MarketingDigital";
import MobileApps from "./pages/MobileApps";
import Automation from "./pages/Automation";
import ITConsulting from "./pages/ITConsulting";
import UrbanTransport from "./pages/UrbanTransport";
import DigitalInvites from "./pages/DigitalInvites";
import Ambassadors from "./pages/Ambassadors";
import WSJAssistant from "./components/WSJAssistant";

function App() {
  return (
    <LanguageProvider>
      <div className="App min-w-0 w-full max-w-full overflow-x-hidden">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/wsj-pedidos" element={<WsjPedidos />} />
            <Route path="/desenvolvimento-web" element={<WebDevelopment />} />
            <Route path="/ecommerce" element={<Ecommerce />} />
            <Route path="/marketing-digital" element={<MarketingDigital />} />
            <Route path="/aplicativos-mobile" element={<MobileApps />} />
            <Route path="/automacao" element={<Automation />} />
            <Route path="/consultoria-ti" element={<ITConsulting />} />
            <Route path="/transporte-urbano" element={<UrbanTransport />} />
            <Route path="/convites-digitais" element={<DigitalInvites />} />
            <Route path="/indique-e-ganhe" element={<Ambassadors />} />
          </Routes>
          <WSJAssistant />
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
